module.exports = __webpack_public_path__ + "static/media/arrowMenu.f9cecbbe.svg";